export function shallowSort<T, K extends keyof T>(
    property: K,
    asNumber?: boolean,
    isDesc?: boolean,
    transformF?: (value: T[K]) => string,
): (a: T, b: T) => number;
export function shallowSort<T>(
    property: string,
    asNumber?: boolean,
    isDesc?: boolean,
    transformF?: (value: unknown) => string,
): (a: T, b: T) => number;
export function shallowSort(
    property: string,
    asNumber?: boolean,
    isDesc?: boolean,
    transformF?: (value: unknown) => string,
) {
    return function (a: any, b: any) {
        let aVal: string | number = ("" + (transformF?.(a[property]) || a[property])).toLowerCase();
        let bVal: string | number = ("" + (transformF?.(b[property]) || b[property])).toLowerCase();
        if (asNumber) {
            aVal = Number(aVal);
            bVal = Number(bVal);
        }
        if (aVal < bVal) {
            return isDesc ? 1 : -1;
        } else if (aVal > bVal) {
            return isDesc ? -1 : 1;
        } else {
            return 0;
        }
    };
}
